import { createApiRequest } from "../common";
import { TransferOrgOwnershipRequestContent, TransferOrgOwnershipResponseContent } from '@equaliq/api-model-v2';

export const transferOrgOwnershipApi = async (request: TransferOrgOwnershipRequestContent): Promise<TransferOrgOwnershipResponseContent> => {
  const apiRequest = createApiRequest<TransferOrgOwnershipResponseContent>('post', '/orgs/transferOwnership');
  return apiRequest(request);
};
